import {Component, Input} from '@angular/core';
import {AppGlobalEventManagerService} from '../../../services/app.globalEventManager.service';
import {RouterLink} from '@angular/router';
import { DestroyableComponent } from '../../../classes/destroyable.component';


@Component({
  selector: 'breadcrumb',
  imports: [
    RouterLink
    ],
  templateUrl: './breadcrumb.layout.directive.html'
})
export class BreadcrumbLayoutDirective extends DestroyableComponent {

    @Input('breadcrumb') breadcrumb :Array<{url:string, title:string}> = [];

    constructor(
      public appGlobalEventManagerService: AppGlobalEventManagerService
    ){
    super();

      this.subscribe(this.appGlobalEventManagerService.breadcrumbEmitter, (breadcrumb:Array<{url:string, title:string}>) => {
        this.breadcrumb = breadcrumb;
      });

    }

}
